<template>
    <li class="item" @click="onJumpToApp(item)">
        <div class="tab">{{ item.startTime | startTime}}</div>
        <div class="status" v-if="item.started">{{timeStr}}</div>
        <van-image class="back" :src="item.coverImageUrl" />
    </li>
</template>

<script>
import utils from '@/utils/common';
import { jumpToActPreview } from '@/utils/util';
export default {
    props: {
        item: Object
    },
    data() {
        return {
            timeStr: ''
        }
    },
    created() {
        if(this.item.started) {
            this.getTime()
        }
    },
    filters: {
        startTime: function(time) {
            let date = new Date(time.replace(new RegExp('-', 'g'), '/'))
            return (date.getMonth() + 1) + '月' + date.getDate() + '日'
        }
    },
    methods: {
        onJumpToApp(item) {
            if(!item.linkValue || !item.started) return
            switch(item.linkType) {
                case 1:     // 不跳转
                    break;
                case 2:     // 店铺
                    utils.jumpToNewPage({
                        url: window.location.origin +'/h5user/brandindex?id=' + item.linkValue,
                        noTitle: '1',
                        action:'{tm:"4090100",tp:"{branchId:'+item.linkValue+'}'
                    });
                    break;
                case 3:     // 活动页
                    jumpToActPreview(item);
                    break;
                default: 
                    break;
            }
        },
        getTime() {
            let day, hour, minute, second, time, timer;
            let endTime = this.item.endTime.replace(new RegExp('-', 'g'), '/')
            this.timeInterval({day, hour, minute, second, endTime, timer});
            timer = setInterval(()=>{
                this.timeInterval({day, hour, minute, second, endTime, timer});
            }, 1000)
        },
        timeInterval({day, hour, minute, second, endTime, timer}) {
            let time = new Date(endTime).getTime() - new Date().getTime()
            if(time<0) {
                return clearInterval(timer)
            }
            day = parseInt(time / (24 * 60 * 60 * 1000), 10)
            hour = parseInt(time / (60 * 60 * 1000) % 24, 10)
            minute = parseInt(time / (60 * 1000) % 60, 10)
            second = parseInt(time / 1000 % 60, 10)
            this.timeStr =`距离结束  ` + `${day?day+'天 ':''}` + `${this.checkTime(hour)}:${this.checkTime(minute)}:${this.checkTime(second)}`
        },
        checkTime(time) {
            if(time<10) {
                time = "0" + time
            }
            return time
        }
    }
}
</script>

<style lang="less" scoped>
.item { 
    width: 635px;
    height: 240px;
    position: relative;
    margin-top: 50px;            
    .back {
        width: 635px;
        height: 240px;
    }

    .tab {
        width: 195px;
        height: 54px;
        position: absolute;
        left: 28px;
        top: -20px;
        z-index: 10;
        font-size: 28px;
        font-weight: 500;
        background-image: url('../../assets/home/calendar_tab@2x.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        text-align: center;
        color: #ffffff;
        line-height: 54px;
    }
    .status {
        // width: 123px;
        height: 38px;
        position: absolute;
        right: 0;
        bottom: 0;
        padding: 0 10px;
        font-size: 18px;
        font-weight: 500;
        line-height: 38px;
        text-align: center;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        border-radius: 10px 0px 10px 0px;
        z-index: 10;
    }
}
</style>